// *******************************************************************************
// 1.0 - TEXT FIELDS
// *******************************************************************************

const textFieldElement = document.querySelectorAll('.mod-input__field');

Array.prototype.forEach.call(textFieldElement, (el) => {
  // eslint-disable-next-line no-unused-vars
  el.addEventListener('focus', (ev) => {
    const parentElement = el.closest('.mod-input');
    parentElement.classList.add('is-focused');
  });

  // eslint-disable-next-line no-unused-vars
  el.addEventListener('blur', (ev) => {
    const parentElement = el.closest('.mod-input');
    if (!el.value) {
      parentElement.classList.remove('is-focused');
    }
  });
});
